import FloatingTool from './FloatingTool.vue';

const MINIMUM_Z_INDEX = 3;

class ToolDisplayManager {
  private toolArray: Array<FloatingTool> = new Array<FloatingTool>();

  updateTool(tool: FloatingTool, hidden: boolean) {
    const index = this.toolArray.findIndex((value) => value == tool);

    if (!hidden) {
      if (index !== -1 && index === this.toolArray.length - 1) {
        return;
      }

      if (index !== -1) {
        this.toolArray.splice(index, 1);
      }
      this.toolArray.push(tool);
    } else {
      if (index !== -1) {
        this.toolArray[index].zIndex = MINIMUM_Z_INDEX - 1;
        this.toolArray.splice(index, 1);
      }
    }

    for (let i = 0; i < this.toolArray.length; i++) {
      this.toolArray[i].zIndex = i + MINIMUM_Z_INDEX;
    }
  }

  getZIndex(tool: FloatingTool): number {
    return this.toolArray.findIndex((value) => value == tool) + MINIMUM_Z_INDEX;
  }

  reset(): void {
    this.toolArray = new Array<FloatingTool>();
  }
}

export default ToolDisplayManager;
